import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Reveal } from './ui-blocks';

const ABIDJAN_IMAGE =
  'https://images.unsplash.com/photo-1648770664367-54d43741edf1?crop=entropy&cs=srgb&fm=jpg&q=80&w=1800';

const Vision = () => {
  const { t } = useLanguage();

  return (
    <section id="vision" data-testid="vision-section" className="noise relative bg-ink text-cream py-32 md:py-44 overflow-hidden">
      <img src={ABIDJAN_IMAGE} alt="" className="absolute inset-0 h-full w-full object-cover opacity-20 grayscale" />
      <div className="absolute inset-0 bg-gradient-to-b from-ink via-ink/70 to-ink" />

      <div className="relative z-10 mx-auto max-w-5xl px-6 md:px-12 text-center">
        <Reveal>
          <span className="eyebrow text-gold justify-center">{t.vision.eyebrow}</span>
        </Reveal>
        <Reveal delay={0.15}>
          <h2 data-testid="vision-statement" className="mt-10 font-heading text-3xl sm:text-4xl lg:text-5xl xl:text-6xl leading-[1.15] tracking-tight">
            {t.vision.lead}
            <em className="text-gold italic font-medium">{t.vision.highlight}</em>
            {t.vision.tail}
          </h2>
        </Reveal>
        <Reveal delay={0.3}>
          <div className="mt-14 flex items-center justify-center gap-4">
            <span className="w-16 h-px bg-cream/30" />
            <span className="w-2 h-2 rounded-full bg-gold" />
            <span className="w-16 h-px bg-cream/30" />
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Vision;
